import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-trash-icon',
	templateUrl: './trash-icon.component.html',
})
export class TrashIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
